import React from 'react';
import { connect } from 'react-redux';
import { updateFieldConsultant , fetchConsultants , setStarIsLoading } from './../../actions/consultant';
import { bindActionCreators } from 'redux';

class KeyConsultantToggle extends React.Component {
  constructor(props) {
    super()
    this.state = {
      isKeyConsultant: false,
    }
  }


  componentDidMount() {


    if (this.props.consultant.content && this.props.consultant.content['information-consultant'].isKeyConsultant === true ) {
      this.setState({ isKeyConsultant: true })
    } else {
      this.setState({ isKeyConsultant: false })
    }
  }

  keyConsultantToggle = () => {
    if (this.props.consultant.writepermission && this.props.user){
      var obj= {
        index: undefined,
        name: "isKeyConsultant",
        parent: "information-consultant",
        value: !this.state.isKeyConsultant
      }
      this.props.updateFieldConsultant( obj ,this.props.consultant._id)
      this.props.fetchConsultants()
      this.setState({ isKeyConsultant: !this.state.isKeyConsultant })
      this.props.setStarIsLoading(true)
    }

  }

  // componentWillUnmount() {
  //   var el = document.getElementById(this.props.id)
  //   el.parentNode.removeChild(el)
  // }

  render() {
    var date = new Date().getTime().toString()
    var id1 = date.split("").reverse().join("") + this.props.consultant._id
    var id2 =  this.props.consultant._id + date
    return (
      <span id={this.props.id}>
        <span onClick={() =>  this.keyConsultantToggle()} >
          { this.state.isKeyConsultant ?
            <span id={"active"} key={"active_"+ id1 } style={{ color: "rgb(139, 195, 74)", marginRight:'10px'}}><i  className="fas fa-star"></i></span>
            :
            <span id={"desactive"} key={"desactive_"+ id2} style={{ marginRight:'10px'}} ><i className="far fa-star" ></i></span>
          }
        </span>
      </span >
    );

  }
}

function mapStateToProps(state) {
  return {
     isloading : state.consultant.starIsLoading
  };
}

const mapDispatchToProps = dispatch => bindActionCreators({
  updateFieldConsultant,
  fetchConsultants,
  setStarIsLoading
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps )(KeyConsultantToggle);
